import queryString from 'core/libs/query-string';

import { bebop as bebopApi } from 'core/api/definitions/bebop';

import { filterRequiredParams } from 'core/utils/api';
import { renderError as defaultRenderError } from 'core/utils/app-status-helper';
import { getOffset } from 'core/utils/url-helper';
import { throwIfHistoryIsMissing } from 'core/utils/query';


export const limit = 15;

export const rawContentQuery = queryParams => {
  throwIfHistoryIsMissing(queryParams, 'rawContentQuery in searchPage.js');

  const {
    card,
    renderError = defaultRenderError,
    location: {
      search,
    },
    history,
  } = queryParams;

  const searchParams = queryString.parse(search);

  return {
    queryKey: ['bebopApi', 'getSearch', {
      ...searchParams,
      offset: getOffset(search, limit),
      limit,
      include: filterRequiredParams([card], 'include'),
      sort: searchParams.topic_type === 'news' ? '-updated_at' : null,
    }],
    queryFn: ({ queryKey: [, method, params] }) => bebopApi[method](params).catch(err => renderError(err, history)),
  };
};
